import React from 'react';
import '../css/FullPageLoader.css';

const FullPageLoader = ({ isVisible, message = "Caricamento in corso...", type = "default" }) => {
  if (!isVisible) return null;

  const overlayClass = `fullpage-loader-overlay ${type !== 'default' ? `loading-${type}` : ''}`;

  return (
    <div className={overlayClass}>
      <div className="fullpage-loader-content">
        <div className="fullpage-loader-spinner"></div>
        <p className="fullpage-loader-message">{message}</p>
      </div>
    </div>
  );
};

export default FullPageLoader; 